<div class="row">
    <div class="col-12 animated fadeIn fast">
        <div class="card border border-info rounded">
            <div class="card-body ">

                <form (ngSubmit)="enviar()">
                    <div class="row">

                        <!-- cliSeleccionado -->
                        <div class="col-4">
                            <div class="input-group border border-dark rounded"
                                 [ngClass]="{ 'has-danger': errores.cliSeleccionado }">
                                <div class="input-group-addon"><i class="fa-solid fa-user"></i></div>
                                <select class="form-control"
                                        [(ngModel)]="cliSeleccionado"
                                        name="cliSeleccionado"
                                        (ngModelChange)="onClienteSelect($event)">
                                    <option value=''>Cliente...</option>
                                    <option *ngFor="let cli of clientesList"
                                            [value]=cli.id>
                                        {{cli.nombre}}
                                    </option>
                                </select>
                            </div>

                            <div *ngIf="enviado && errores.cliSeleccionado"
                                 class="form-control-feedback">
                                <span class="text-danger">{{ errores.cliSeleccionado }}</span>
                            </div>
                        </div>


                        <!-- fechaDesde -->
                        <div class="col-3">
                            <div class="input-group border border-dark rounded"
                                 [ngClass]="{ 'has-danger': errores.fechaDesde }">
                                <div class="input-group-addon">Desde</div>
                                <input class="form-control"
                                       type="date"
                                       [(ngModel)]="fechaDesde"
                                       name="fechaDesde"
                                       required>
                            </div>
                            <div *ngIf="enviado && errores.fechaDesde"
                                 class="form-control-feedback">
                                <span class="text-danger">{{ errores.fechaDesde }}</span>
                            </div>
                        </div>


                        <!-- fechaHasta -->
                        <div class="col-3">
                            <div class="input-group border border-dark rounded"
                                 [ngClass]="{ 'has-danger': errores.fechaHasta }">
                                <div class="input-group-addon">Hasta</div>
                                <input class="form-control"
                                       type="date"
                                       [(ngModel)]="fechaHasta"
                                       name="fechaHasta"
                                       required>
                            </div>
                            <div *ngIf="enviado && errores.fechaHasta"
                                 class="form-control-feedback">
                                <span class="text-danger">{{ errores.fechaHasta }}</span>
                            </div>
                        </div>


                        <!-- Submit -->
                        <div class="col-2">
                            <button [disabled]="loading"
                                    type="submit"
                                    class="ml-2 btn waves-effect waves-light btn-rounded btn-success">
                                <i class="fa fa-spinner fa-spin"
                                   *ngIf="loading"></i> Enviar</button>
                        </div>


                    </div><!-- row -->
                </form>

            </div>
        </div>
    </div>
</div> <!-- row -->

<div class="row">

    <!-- Entradas -->
    <div class="col-6 animated fadeIn fast">
        <app-facturacion-entradas [datosCabecera]="datosCabecera"
                                  (totalEntradas)="handleTotalEntradas($event)"></app-facturacion-entradas>
    </div>

    <!-- Almacenaje -->
    <div class="col-6 animated fadeIn fast  ">
        <app-facturacion-almacenaje [datosCabecera]="datosCabecera"
                                    (totalAlmacenaje)="handleTotalAlmacenaje($event)"></app-facturacion-almacenaje>
    </div>

    <!-- Salidas -->
    <div class="col-12 animated fadeIn fast">
        <app-facturacion-salidas [datosCabecera]="datosCabecera"
                                 (totalSalidas)="handleTotalSalidas($event)"
                                 (totalSalidasB2B)="handleTotalSalidasB2B($event)"
                                 (totalSalidasB2C)="handleTotalSalidasB2C($event)">
        </app-facturacion-salidas>
    </div>



</div>
<div class="row">
    <!-- Columna izquierda: Seguros y Devoluciones apiladas -->
    <div class="col-6">
        <!-- Seguro -->
        <div class="animated fadeIn fast mb-3">
            <app-facturacion-seguros [datosCabecera]="datosCabecera"
                                     (totalSeguros)="handleTotalSeguros($event)"></app-facturacion-seguros>
        </div>

        <!-- Devoluciones -->
        <div class="animated fadeIn fast">
            <app-facturacion-devoluciones [datosCabecera]="datosCabecera"
                                          (totalDevoluciones)="handleTotalDevoluciones($event)"></app-facturacion-devoluciones>
        </div>
    </div>

    <!-- Columna derecha: Totales -->
    <div class="col-6">
        <!-- Totales -->
        <div class="animated fadeIn fast">
            <span *ngIf="granTotal > 0">
                <div class="card border border-info rounded border-grueso">
                    <div class="card-body">

                        <div class="d-flex justify-content-between align-items-center">

                            <h2>TOTALES</h2>

                            <button class="btn waves-effect waves-light btn-primary mb-2"
                                    [disabled]="loading"
                                    (click)="confirmaClick()">
                                <i class="fa fa-spinner fa-spin"
                                   *ngIf="loading"></i> Confirmar
                            </button>

                            <!-- Xlsx -->
                            <button [disabled]="loading"
                                    class="btn waves-effect waves-light btn-success mb-2"
                                    type="button"
                                    (click)="facCrearXls()">
                                <i class="fa fa-spinner fa-spin"
                                   *ngIf="loading"></i> Generar Xlsx
                            </button>

                            <!-- Pdf -->
                            <button class="btn waves-effect waves-light btn-seccondary mb-2"
                                    [disabled]="loading"
                                    (click)="generarPdf()">
                                <i class="fa fa-spinner fa-spin"
                                   *ngIf="loading"></i> Generar resumen Pdf
                            </button>

                            <span *ngIf="linkPdf == ''"
                                  style="width: 2em;"></span>
                            <a href="{{ linkPdf }}"
                               *ngIf="linkPdf != ''"
                               title="Descargar Pdf"
                               class="text-secondary"
                               target="_blank">
                                <i class="fa fa-file fa-2x"></i>
                            </a>

                        </div>

                        <table class="table table-sm table-striped table-bordered table-hover">

                            <thead>
                                <tr>
                                    <th class="text-info"
                                        style="text-align: right;">Totales en el periodo </th>
                                    <th style="text-align: right;">Importes </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="text-align: right;">Entradas
                                        <span *ngIf="linkXls.entradas"
                                              title="Descargar Excel">
                                            <a href="{{ linkXls.entradas }}"><i class="text-secondary fa fa-file-excel fa-2x"></i></a>
                                        </span>




                                    </td>
                                    <td style="text-align: right;">{{ totalEntradas | euroCurrency }} </td>
                                </tr>
                                <tr>
                                    <td style="text-align: right;">Almacenaje
                                        <span *ngIf="linkXls.almacenaje"
                                              title="Descargar Excel">
                                            <a href="{{ linkXls.almacenaje }}"><i class="text-secondary fa fa-file-excel fa-2x"></i></a>
                                        </span>
                                    </td>
                                    <td style="text-align: right;">{{ totalAlmacenaje | euroCurrency }} </td>
                                </tr>
                                <tr>
                                    <td style="text-align: right;">Salidas
                                        <span *ngIf="linkXls.salidas"
                                              title="Descargar Excel">
                                            <a href="{{ linkXls.salidas }}"><i class="text-secondary fa fa-file-excel fa-2x"></i></a>
                                        </span>
                                    </td>
                                    <td style="text-align: right;">{{ totalSalidas | euroCurrency }} </td>
                                </tr>
                                <tr>
                                    <td style="text-align: right;">Seguros
                                        <span *ngIf="linkXls.seguros"
                                              title="Descargar Excel">
                                            <a href="{{ linkXls.seguros }}"><i class="text-secondary fa fa-file-excel fa-2x"></i></a>
                                        </span>
                                    </td>
                                    <td style="text-align: right;">{{ totalSeguros | euroCurrency }} </td>
                                </tr>
                                <tr>
                                    <td style="text-align: right;">Devoluciones
                                        <span *ngIf="linkXls.devoluciones"
                                              title="Descargar Excel">
                                            <a href="{{ linkXls.devoluciones }}"><i class="text-secondary fa fa-file-excel fa-2x"></i></a>
                                        </span>
                                    </td>
                                    <td style="text-align: right;">{{ totalDevoluciones | euroCurrency }} </td>
                                </tr>
                            </tbody>

                            <tfoot>
                                <tr class="total-row">
                                    <td style="text-align: right;"><strong> Gran Total</strong></td>
                                    <td style="text-align: right;"><strong>{{ granTotal | euroCurrency }}</strong></td>
                                </tr>
                            </tfoot>
                        </table>

                    </div>
                </div>
            </span>
        </div>
    </div>
</div>
